import { css } from 'emotion';
import themeConfig from '@lyearn-team/theme-config';

const darkAccentTextView = () => css`
  padding: 0 5px !important;
  font-size: 12px !important;
  color: ${themeConfig.color.dark.emerald} !important;
  :hover:enabled {
    opacity: 0.9 !important;
    color: ${themeConfig.color.dark.emerald} !important;
  }
`;

export default {
  darkAccentTextView
};
